// src/components/equipements/CodeDesignation.tsx — SCE Issues
// Le code de désignation de la fiche équipement (05/10) : au survol, chaque
// position décodée — code, ce qu'elle règle, sa valeur. Colonnes et systèmes
// Hipersep seulement (`utils/codeDesignation`) ; tout autre code s'affiche tel
// quel, sans bulle.

import { Infobulle } from '@/components/ui/Infobulle'
import { decoderDesignation } from '@/utils/codeDesignation'

export function CodeDesignation({ code }: { code: string }): JSX.Element {
  const decode = decoderDesignation(code)
  if (!decode) return <span>{code}</span>

  const remarques = [
    decode.manquantes > 0 &&
      `Code incomplet dans Windchill : ${decode.manquantes} position${decode.manquantes > 1 ? 's' : ''} manquante${decode.manquantes > 1 ? 's' : ''}.`,
    decode.surplus && `Caractères en trop : ${decode.surplus}`,
  ].filter(Boolean)

  return (
    <Infobulle
      titre={`${decode.titre} ${decode.execution === 'Custom' ? 'Custom' : 'modulaire'} — code de désignation`}
      largeur={460}
      detail={remarques.join(' ') || undefined}
      contenu={
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto auto 1fr',
            columnGap: 10,
            rowGap: 1,
            margin: '6px 0 4px',
          }}
        >
          {/* Une option absente (« Non ») en retrait : ce qui est présent se lit d'abord. */}
          {decode.champs.map((c, i) => {
            const retrait = c.absent ? 0.55 : 1
            return (
              <div key={i} style={{ display: 'contents' }}>
                <span style={{ opacity: 0.6 * retrait, fontFamily: 'monospace' }}>{c.code}</span>
                <span style={{ opacity: 0.75 * retrait }}>{c.libelle}</span>
                <span style={{ opacity: retrait, fontStyle: c.valeur === null ? 'italic' : 'normal' }}>
                  {c.valeur ?? 'Inconnu'}
                </span>
              </div>
            )
          })}
        </div>
      }
    >
      <span tabIndex={0} style={{ cursor: 'help', textDecoration: 'underline dotted', textUnderlineOffset: 3 }}>
        {code}
      </span>
    </Infobulle>
  )
}
